export default __webpack_public_path__ + "static/media/siglas.b4ccb548.png";